export default "__VITE_PUBLIC_ASSET__bbf9b8c2__"